import { baseCardsSchema } from '../Cards/schema';

export const listingCardsSchema = ({ intl }) => {
  return baseCardsSchema({ intl });
};
